<template>
  <div>
    <v-app-bar clipped-left app dark dense color="bluePcm">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" class="ml-n3" />

      <ClientNameAppbar />
      <AppBar />
    </v-app-bar>

    <v-navigation-drawer
      clipped
      :permanent="$vuetify.breakpoint.mdAndUp"
      app
      :mini-variant="!drawer"
      :mini-variant-width="$vuetify.breakpoint.mdAndUp ? '70' : ''"
      color="background"
      v-model="drawer"
    >
      <ListNavigationDrawerPabx :drawer="!drawer" />
    </v-navigation-drawer>
  </div>
</template>

<script>
import ListNavigationDrawerPabx from "./ListNavigationDrawerPabx";
import ClientNameAppbar from "@/componentes/ClientNameAppbar";
import AppBar from "@/componentes/AppBar";

export default {
  name: "navigationDrawerMediumAndUp",
  components: { ClientNameAppbar, AppBar, ListNavigationDrawerPabx },

  data: () => ({
    drawer: false,
  }),
};
</script>

<style>
.app {
  background-color: var(--v-background-base);
}
</style>
